var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:([_vm.pageBgStyle]),attrs:{"id":"app"}},[_c('div',{staticClass:"header"},[_c('Header')],1),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_c('qrCode'),_c('sideBar'),(_vm.showApplyform)?_c('applyform',{attrs:{"tid":_vm.tid}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }